var _rect, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEsseeIkoni(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 47,
    viewBox: "0 0 140 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 139,
    height: 46,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3635 35H13.2442L19.5209 16.8182H24.4747L30.7425 35H26.6231L22.0688 20.973H21.9268L17.3635 35ZM17.1061 27.8533H26.8362V30.854H17.1061V27.8533Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 11V36",
    stroke: "black",
    strokeWidth: 0.6
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsseeIkoni);
export default __webpack_public_path__ + "static/media/Essee_ikoni.910257b318ccccd67b5831c64fb6bceb.svg";
export { ForwardRef as ReactComponent };